import { Utils } from "@simplyk/common";
import { inferRouterInputs } from "@trpc/server";

import { AppRouterType } from "@/common/helpers/trpc";
import { TicketingOutput } from "@/common/types/trpc";
import { getEligibleAmountFromRate } from "@/features/LiveFormEditor/Steps/helpers/mapper";
import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

type EditAddOnInput = inferRouterInputs<AppRouterType>["updateTicketingAddOns"]["addOns"][number];

export const mapDataToEditAddOns = (addOns: RateData[], apiTicketing: TicketingOutput): EditAddOnInput[] => {
  const registeredRatesById = new Map(apiTicketing.rates?.map((registeredRate) => [registeredRate.id, registeredRate]));

  return addOns.map((addOn, index) => {
    const registeredRate = registeredRatesById.get(addOn.id);
    const rateField = registeredRate?.rateFields?.find((field) => field.locale === apiTicketing.locale);

    const photos = (addOn.photos ?? []).map((photo) => photo.photoUrl).filter(Utils.notEmpty);

    return {
      id: addOn.id,
      amount: addOn.amount,
      eligibleAmount: getEligibleAmountFromRate(addOn),
      seats: parseValueToEditInput(addOn.seats),
      maximumToBuy: addOn.rateMaximumNumberToBuy ? parseInt(addOn.rateMaximumNumberToBuy.toString()) : 10,
      rateFields: [
        {
          id: rateField?.id,
          title: addOn.name,
          description: addOn.description,
        },
      ],
      sortIndex: index,
      photos,
      taxIds: addOn.taxIds,
    };
  });
};

const parseValueToEditInput = (value: number | null | undefined) => {
  if (value === undefined || value === null || value.toString() === "") {
    return null;
  }
  return parseInt(value.toString());
};
